<template>
  <Badge :variant="ALLOCATION_STATUS_VARIANT[status]" :size="size">
    {{ $t(`allocationStatus.${status}`) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { AllocationStatus } from '@carvia/ros-client-types';

defineProps<{
  status: AllocationStatus;
  size?: 'sm' | 'md';
}>();

const ALLOCATION_STATUS_VARIANT: Record<AllocationStatus, BadgeVariant> = {
  [AllocationStatus.NOT_CONFIRMED]: 'info',
  [AllocationStatus.CONFIRMED]: 'success',
  [AllocationStatus.HANDED_OVER]: 'walnut',
  [AllocationStatus.RETURNED]: 'obsidian',
};
</script>
